import React from 'react';

import ResponsiveVideo from 'Site/Ui/ResponsiveVideo';
import ContentController from 'RLX/Controllers/ContentController';

class ResponsiveVideoEditor extends ContentController {
  constructor (props) {
    super(props);
    this.getPreview = this.getPreview.bind(this);
  }

  static getInitialShape () {
    return {
      props: {
        heightOffset: 0,
        widthOffset: 0,
        id: null
      }
    };
  }

  getBlockName () {
    return 'Video Block';
  }

  getClassName () {
    return 'ResponsiveVideoEditor';
  }

  getContent () {
    const { props } = this.props.content;

    const heightOffset = (typeof props.heightOffset === 'number')
      ? props.heightOffset - 50
      : -50;
    const widthOffset = (typeof props.widthOffset === 'number')
      ? props.widthOffset - 50
      : -50;

    return (
      <ResponsiveVideo
        {...props}
        heightOffset={heightOffset}
        widthOffset={widthOffset}
      />
    );
  }

  getFields () {
    const faded = { opacity: 0.5 };
    const { content } = this.props;
    return [
      {
        type: 'text',
        icon: 'youtube-play',
        required: true,
        label: 'YouTube Video ID',
        value: content.props.id,
        onChange: this.applyUpdate((id, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, id } };
        })
      },
      {
        type: 'number',
        icon: 'expand',
        validate: 'optionalNumber',
        label: <span>Width Offset <span style={faded}>(in px, Optional)</span></span>,
        value: content.props.widthOffset,
        onChange: this.applyUpdate((widthOffset, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, widthOffset } };
        })
      },
      {
        type: 'number',
        icon: 'expand',
        validate: 'optionalNumber',
        label: <span>Height Offset <span style={faded}>(in px, Optional)</span></span>,
        value: content.props.heightOffset,
        onChange: this.applyUpdate((heightOffset, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, heightOffset } };
        })
      },
      {
        content: (
          <p className="briefing">Preview is shown at 50% actual size.</p>
        )
      }
    ];
  };
};

export default ResponsiveVideoEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/ResponsiveVideoEditor.jsx